/*!
 * Yuaia – Curl Finder Quiz v1.0
 * Mobile-first produktquiz. Data (tekster, produkter, priser) leveres af
 * sections/curl-finder-quiz.liquid som JSON, så alt er oversætteligt og
 * markedsspecifikt. Ingen variant-ID'er er hardcodet her.
 */
(function () {
  'use strict';

  var STEP_START = 0;
  var STEP_RESULT = 6;
  var QUESTION_IDS = ['q1', 'q2', 'q3', 'q4', 'q5'];

  /* ------------------------------------------------------------------ *
   * Regelmotor (spec afsnit 4). Første match vinder. Q1 påvirker ikke match.
   * ------------------------------------------------------------------ */
  function pickResult(a) {
    a = a || {};
    var holdOrDefined = a.q3 === 'hold' || a.q4 === 'defined';
    if (a.q3 === 'refresh' && a.q5 === 'simple') return 'R1';
    if (a.q2 === 'fine' || a.q3 === 'weight') return 'R2';
    if (a.q3 === 'frizz' && a.q5 === 'simple') return 'R3';
    if (a.q3 === 'frizz' && (a.q5 === 'style' || a.q5 === 'wash')) return 'R4';
    if (a.q4 === 'beach') return 'R5';
    if (holdOrDefined && a.q5 === 'simple') return 'R6';
    if (holdOrDefined) return 'R7';
    if (a.q3 === 'refresh') return 'R8';
    return 'R9';
  }

  /* ------------------------------------------------------------------ *
   * Hjælpere
   * ------------------------------------------------------------------ */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    format = format || '{{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    function d(n, prec, thou, dec) {
      var num = (n / 100).toFixed(prec);
      var parts = num.split('.');
      var ints = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
      return ints + (parts[1] ? dec + parts[1] : '');
    }
    var v;
    switch (key) {
      case 'amount_no_decimals': v = d(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = d(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = d(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = d(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = d(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': v = d(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = d(cents, 2, ' ', '.'); break;
      default: v = d(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  var WAVE = '<svg class="ycq__wave" viewBox="0 0 1440 64" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path d="M0 34c160 22 340 30 540 18S900 6 1100 10s260 18 340 26v28H0z"/></svg>';
  var STARS = '<span class="ycq__stars" aria-hidden="true">' + new Array(6).join('<svg viewBox="0 0 20 20"><path d="M10 1.5l2.6 5.5 6 .8-4.4 4.1 1.1 5.9L10 15l-5.3 2.8 1.1-5.9L1.4 7.8l6-.8z"/></svg>') + '</span>';
  var BAG = '<svg class="ycq__btn-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 8h12l-1 12H7L6 8z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M9 8V6.5a3 3 0 016 0V8" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';

  function miniAdd(item, label) {
    if (!item || !item.available || !item.variantId) return '';
    return '<button type="button" class="ycq__mini-add" data-ycq-action="add-one" data-variant="' + esc(item.variantId) + '">' + esc(label) + '</button>';
  }

  function tpl(str, vars) {
    return String(str || '').replace(/\{(\w+)\}/g, function (_, k) {
      return vars[k] != null ? vars[k] : '';
    });
  }

  function storage() {
    try {
      var s = window.sessionStorage;
      s.setItem('__ycq', '1');
      s.removeItem('__ycq');
      return s;
    } catch (e) {
      return null;
    }
  }

  function jsonFetch(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, opts.headers || {});
    opts.credentials = 'same-origin';
    return fetch(url, opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (body) {
        if (!res.ok) {
          var err = new Error(body.description || body.message || 'HTTP ' + res.status);
          err.status = res.status;
          err.body = body;
          throw err;
        }
        return body;
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Quiz
   * ------------------------------------------------------------------ */
  function Quiz(root) {
    this.root = root;
    var cfgEl = root.querySelector('script[data-ycq-config]');
    this.cfg = JSON.parse(cfgEl.textContent);
    this.cfg.results = this.cfg.results || {};
    this.s = this.cfg.strings || {};
    var clean = function (arr) {
      return (arr || []).map(function (x) { return String(x || '').trim(); }).filter(Boolean);
    };
    if (this.cfg.start) this.cfg.start.usps = clean(this.cfg.start.usps);
    this.cfg.trust = clean(this.cfg.trust);
    Object.keys(this.cfg.results).forEach(function (k) {
      var r = this.cfg.results[k];
      r.routine = clean(r.routine);
      r.items = (r.items || []).filter(function (i) { return i && i.variantId; });
    }, this);
    this.store = storage();
    this.key = 'ycq:v1:' + (this.cfg.id || 'default');
    this.view = root.querySelector('[data-ycq-view]');
    this.busy = false;
    this.cartTotal = null;
    this.state = this.load() || this.freshState();
    this.bind();
    this.render(false);
  }

  Quiz.prototype.qa = function (sel) {
    var out = Array.prototype.slice.call(this.view.querySelectorAll(sel));
    if (this.stickyEl) out = out.concat(Array.prototype.slice.call(this.stickyEl.querySelectorAll(sel)));
    return out;
  };

  Quiz.prototype.removeSticky = function () {
    if (this.stickyEl && this.stickyEl.parentNode) this.stickyEl.parentNode.removeChild(this.stickyEl);
    this.stickyEl = null;
  };

  Quiz.prototype.freshState = function () {
    return { step: STEP_START, answers: {}, opts: {}, flags: {}, added: false };
  };

  Quiz.prototype.load = function () {
    if (!this.store || this.cfg.designMode) return null;
    try {
      var st = JSON.parse(this.store.getItem(this.key) || 'null');
      if (st && typeof st.step === 'number' && st.answers) { st.added = false; return st; }
    } catch (e) {}
    return null;
  };

  Quiz.prototype.save = function () {
    if (!this.store) return;
    try { this.store.setItem(this.key, JSON.stringify(this.state)); } catch (e) {}
  };

  /* ---------- tracking ---------- */
  Quiz.prototype.track = function (name, params) {
    var payload = Object.assign({ event: name, quiz_id: 'curl_finder', quiz_version: '1.0' }, params || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try { document.dispatchEvent(new CustomEvent('ycq:track', { detail: payload })); } catch (e) {}
    if (this.cfg.debug && window.console) console.log('[curl-quiz]', payload);
  };

  Quiz.prototype.trackOnce = function (flag, name, params) {
    if (this.state.flags[flag]) return;
    this.state.flags[flag] = true;
    this.save();
    this.track(name, params);
  };

  /* ---------- events ---------- */
  Quiz.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ycq-action]');
      if (!t || !self.root.contains(t)) return;
      var action = t.getAttribute('data-ycq-action');
      if (action === 'start') self.start();
      else if (action === 'answer') self.answer(t.getAttribute('data-q'), t.getAttribute('data-value'), t);
      else if (action === 'back') self.back();
      else if (action === 'restart') self.restart();
      else if (action === 'add') { e.preventDefault(); self.addToCart(); }
      else if (action === 'add-one') { e.preventDefault(); e.stopPropagation(); self.addOne(t); }
    });
    this.root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-ycq-opt]')) return;
      self.toggleOpt(t.getAttribute('data-ycq-opt'), t.checked);
    });
  };

  Quiz.prototype.start = function () {
    this.state.step = 1;
    this.save();
    this.trackOnce('started', 'curl_quiz_start', {});
    this.render(true);
  };

  Quiz.prototype.answer = function (qid, value, btn) {
    if (this.busy) return;
    var self = this;
    var n = QUESTION_IDS.indexOf(qid) + 1;
    this.state.answers[qid] = value;
    this.track('curl_quiz_answer', {
      quiz_question_number: n,
      quiz_question_id: qid,
      quiz_answer_value: value
    });
    var buttons = this.view.querySelectorAll('[data-ycq-action="answer"]');
    for (var i = 0; i < buttons.length; i++) buttons[i].setAttribute('aria-pressed', buttons[i] === btn ? 'true' : 'false');
    this.busy = true;
    setTimeout(function () {
      self.busy = false;
      if (n < 5) {
        self.state.step = n + 1;
      } else {
        self.state.step = STEP_RESULT;
        // Ny gennemførsel: nulstil resultat-specifikke valg og flags
        self.state.opts = {};
        self.state.added = false;
        self.state.flags.resultViewed = null;
        self.state.flags.completed = null;
        var res = self.resolve();
        self.trackOnce('completed', 'curl_quiz_complete', Object.assign({ quiz_result_id: res.id }, self.answerParams()));
      }
      self.save();
      self.render(true);
    }, 220);
  };

  Quiz.prototype.back = function () {
    if (this.state.step > 1 && this.state.step <= STEP_RESULT) {
      this.state.step -= 1;
      this.save();
      this.render(true);
    }
  };

  Quiz.prototype.restart = function () {
    this.state = this.freshState();
    this.state.step = 1;
    this.save();
    this.trackOnce('started', 'curl_quiz_start', { quiz_restart: true });
    this.render(true);
  };

  Quiz.prototype.answerParams = function () {
    var a = this.state.answers;
    return { quiz_q1: a.q1 || '', quiz_q2: a.q2 || '', quiz_q3: a.q3 || '', quiz_q4: a.q4 || '', quiz_q5: a.q5 || '' };
  };

  /* ---------- resultat ---------- */
  function resultAvailable(r) {
    return !!(r && r.items && r.items.length && r.items.every(function (i) { return i.available && i.variantId; }));
  }

  Quiz.prototype.resolve = function () {
    var primary = pickResult(this.state.answers);
    var id = primary;
    var r = this.cfg.results[id];
    var seen = {};
    while (r && !resultAvailable(r) && r.fallback && r.fallback !== 'none' && !seen[r.fallback]) {
      seen[id] = true;
      id = r.fallback;
      r = this.cfg.results[id];
    }
    if (!resultAvailable(r)) {
      var results = this.cfg.results;
      var alt = resultAvailable(results.R9) ? 'R9' : Object.keys(results).filter(function (k) { return resultAvailable(results[k]); })[0];
      if (alt) { id = alt; r = results[alt]; }
    }
    return { id: id, primaryId: primary, result: r || null, available: resultAvailable(r) };
  };

  Quiz.prototype.upsells = function (res) {
    var out = [];
    var r = res.result;
    if (!r) return out;
    var cartIds = (!this.state.added && this.cartItems) ? this.cartItems.map(function (li) { return li.variant_id; }) : [];
    var inItems = function (item) {
      return r.items.some(function (i) { return i.variantId === item.variantId; }) || cartIds.indexOf(item.variantId) !== -1;
    };
    var w = this.cfg.wash;
    if (this.state.answers.q5 === 'wash' && w && w.available && w.variantId && !r.includesWash && !inItems(w)) {
      out.push({ key: 'wash', item: w, label: this.s.washLabel, note: this.s.washNote, defaultOn: true });
    }
    var u = r.upsell;
    if (u && u.available && u.variantId && !inItems(u) && !(w && u.variantId === w.variantId && out.length)) {
      out.push({ key: 'extra', item: u, label: r.upsellLabel || u.title, note: r.upsellNote, defaultOn: false });
    }
    return out;
  };

  Quiz.prototype.optOn = function (u) {
    var v = this.state.opts[u.key];
    return v == null ? u.defaultOn : !!v;
  };

  Quiz.prototype.toggleOpt = function (key, on) {
    this.state.opts[key] = !!on;
    if (this.state.added) {
      this.state.added = false;
      var btn = this.view.querySelector('[data-ycq-main-cta]');
      if (btn) btn.innerHTML = BAG + '<span>' + esc(this.s.addCta) + '</span>';
    }
    this.save();
    var res = this.resolve();
    var u = this.upsells(res).filter(function (x) { return x.key === key; })[0];
    this.track('curl_quiz_upsell_select', {
      quiz_result_id: res.id,
      quiz_upsell: key,
      quiz_upsell_selected: !!on,
      quiz_product_ids: u ? [String(u.item.productId)] : [],
      quiz_variant_ids: u ? [String(u.item.variantId)] : [],
      value: u ? u.item.price / 100 : 0,
      currency: this.cfg.currency
    });
    this.updateTotals(res);
  };

  Quiz.prototype.selection = function (res) {
    var self = this;
    // Tilvalg lægges i kurven med deres egen knap og indgår ikke i rutinens samlede pris
    return res.result ? res.result.items.slice() : [];
  };

  Quiz.prototype.compareSum = function (items) {
    return items.reduce(function (t, i) { return t + Math.max(Number(i.compareAt) || 0, Number(i.price) || 0) * (i.qty || 1); }, 0);
  };

  Quiz.prototype.sum = function (items) {
    return items.reduce(function (t, i) { return t + (Number(i.price) || 0) * (i.qty || 1); }, 0);
  };

  /* ---------- rendering ---------- */
  Quiz.prototype.render = function (focus) {
    var st = this.state.step;
    var html;
    if (st === STEP_START) html = this.renderStart();
    else if (st >= 1 && st <= 5) html = this.renderQuestion(st);
    else html = this.renderResult();
    this.removeSticky();
    this.view.innerHTML = html;
    this.root.setAttribute('data-step', st === STEP_RESULT ? 'result' : st === STEP_START ? 'start' : 'question');
    if (st === STEP_RESULT) this.afterResultRender();
    if (focus) {
      var h = this.view.querySelector('[data-ycq-focus]');
      var top = this.root.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) {
        var offset = this.cfg.scrollOffset || 90;
        window.scrollTo({ top: window.pageYOffset + top - offset, behavior: 'smooth' });
      }
      if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    }
  };

  Quiz.prototype.renderStart = function () {
    var c = this.cfg.start || {};
    var usps = (c.usps || []).map(function (u) { return '<li>' + esc(u) + '</li>'; }).join('');
    return '' +
      '<div class="ycq__screen ycq__screen--start">' +
        '<div class="ycq__hero">' +
          '<div class="ycq__hero-inner">' +
            '<div class="ycq__hero-body">' +
              (c.rating ? '<p class="ycq__rating">' + STARS + '<span>' + esc(c.rating) + '</span></p>' : '') +
              (c.kicker ? '<p class="ycq__kicker">' + esc(c.kicker) + '</p>' : '') +
              '<h1 class="ycq__title" tabindex="-1" data-ycq-focus>' + esc(c.heading) + '</h1>' +
              '<p class="ycq__lead">' + esc(c.subheading) + '</p>' +
              '<button type="button" class="ycq__btn ycq__btn--light" data-ycq-action="start">' + esc(c.cta) + '</button>' +
              (usps ? '<ul class="ycq__usps">' + usps + '</ul>' : '') +
            '</div>' +
            (c.image ? '<div class="ycq__hero-media"><img src="' + esc(c.image) + '" alt="" loading="eager" width="900" height="1000"></div>' : '') +
          '</div>' +
          WAVE +
        '</div>' +
      '</div>';
  };

  Quiz.prototype.renderQuestion = function (n) {
    var q = this.cfg.questions[n - 1];
    var current = this.state.answers[q.id];
    var hasImages = q.answers.some(function (a) { return a.image; });
    var answers = q.answers.map(function (a, i) {
      var pressed = current === a.value;
      return '<li>' +
        '<button type="button" class="ycq__answer' + (a.image ? ' ycq__answer--img' : '') + '" data-ycq-action="answer" data-q="' + esc(q.id) + '" data-value="' + esc(a.value) + '" aria-pressed="' + (pressed ? 'true' : 'false') + '">' +
          (a.image ? '<span class="ycq__answer-media"><img src="' + esc(a.image) + '" alt="" loading="lazy" width="160" height="160"></span>' : '') +
          '<span class="ycq__answer-letter" aria-hidden="true">' + String.fromCharCode(65 + i) + '</span>' +
          '<span class="ycq__answer-label">' + esc(a.label) + '</span>' +
          '<span class="ycq__answer-check" aria-hidden="true"></span>' +
        '</button>' +
      '</li>';
    }).join('');
    var pct = Math.round((n / 5) * 100);
    return '' +
      '<div class="ycq__screen ycq__screen--question">' +
        '<div class="ycq__topbar">' +
          (n > 1
            ? '<button type="button" class="ycq__back" data-ycq-action="back"><span aria-hidden="true">←</span> ' + esc(this.s.back) + '</button>'
            : '<span></span>') +
          '<span class="ycq__count">' + esc(tpl(this.s.progress, { current: n, total: 5 })) + '</span>' +
          '<span class="ycq__brand" aria-hidden="true">Twirl and Curl</span>' +
        '</div>' +
        '<div class="ycq__progress" role="progressbar" aria-valuemin="1" aria-valuemax="5" aria-valuenow="' + n + '" aria-label="' + esc(tpl(this.s.progress, { current: n, total: 5 })) + '">' +
          '<span style="width:' + pct + '%"></span>' +
        '</div>' +
        '<h2 class="ycq__question" tabindex="-1" data-ycq-focus>' + esc(q.title) + '</h2>' +
        (q.subtitle ? '<p class="ycq__hint">' + esc(q.subtitle) + '</p>' : '') +
        '<ul class="ycq__answers' + (hasImages ? ' ycq__answers--grid' : '') + '" role="list">' + answers + '</ul>' +
      '</div>';
  };

  Quiz.prototype.personalText = function () {
    var a = this.state.answers;
    var p = this.cfg.personal || {};
    var parts = [];
    var challenge = p.q3 && p.q3[a.q3];
    var goal = p.q4 && p.q4[a.q4];
    if (challenge && goal) parts.push(tpl(p.intro, { challenge: challenge, goal: goal }));
    if (p.outro) parts.push(p.outro);
    if (a.q1 === 'unknown') {
      if (p.q1Unknown) parts.push(p.q1Unknown);
    } else if (p.q1 && p.q1[a.q1]) {
      parts.push(tpl(p.q1Template, { curl: p.q1[a.q1] }));
    }
    return parts;
  };

  Quiz.prototype.renderResult = function () {
    var self = this;
    var s = this.s;
    var res = this.resolve();
    var r = res.result;
    var fmt = this.cfg.moneyFormat;

    if (!r || !r.items.length) {
      var editorHint = this.cfg.designMode
        ? '<p class="ycq__editor-note">Editor: resultat ' + esc(res.primaryId) + ' mangler eller har ingen produkter. Tilføj en Resultat-blok med ' + esc(res.primaryId) + ' og vælg produkter.</p>'
        : '';
      return '<div class="ycq__screen ycq__screen--result">' +
        '<div class="ycq__band">' +
          '<div class="ycq__band-inner">' +
            '<p class="ycq__pill">Ups</p>' +
            '<h2 class="ycq__match" tabindex="-1" data-ycq-focus>' + esc(s.noResultTitle) + '</h2>' +
            '<div class="ycq__personal"><p>' + esc(s.noResultText) + '</p></div>' +
            '<div class="ycq__noresult-actions">' +
              '<button type="button" class="ycq__btn ycq__btn--light" data-ycq-action="restart">' + esc(s.restart) + '</button>' +
              (this.cfg.collectionUrl ? '<a class="ycq__btn ycq__btn--secondary" href="' + esc(this.cfg.collectionUrl) + '">' + esc(s.browseCollection) + '</a>' : '') +
            '</div>' +
          '</div>' +
          WAVE +
        '</div>' +
        editorHint +
      '</div>';
    }

    var personal = this.personalText().map(function (t) { return '<p>' + esc(t) + '</p>'; }).join('');
    var a1 = this.state.answers.q1;
    var heroImage = (this.cfg.curlImages && this.cfg.curlImages[a1]) || '';

    var cards = r.items.map(function (i) {
      return '<li class="ycq__product">' +
        '<a class="ycq__product-media" href="' + esc(i.url) + '" target="_blank" rel="noopener">' +
          (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" loading="lazy" width="300" height="300">' : '') +
        '</a>' +
        '<div class="ycq__product-info">' +
          '<a class="ycq__product-title" href="' + esc(i.url) + '" target="_blank" rel="noopener">' + esc(i.title) + '</a>' +
          (i.contents ? '<span class="ycq__product-contents">' + esc(i.contents) + '</span>' : '') +
          '<span class="ycq__product-price">' +
            (i.compareAt > i.price ? '<s class="ycq__compare">' + esc(formatMoney(i.compareAt, fmt)) + '</s> ' : '') +
            esc(formatMoney(i.price, fmt)) +
            (i.compareAt > i.price ? ' <span class="ycq__save-badge">' + esc(tpl(s.saveBadge, { amount: formatMoney(i.compareAt - i.price, fmt) })) + '</span>' : '') +
          '</span>' +
          (!i.available ? '<span class="ycq__soldout">' + esc(s.soldOut) + '</span>' : miniAdd(i, s.addOne)) +
        '</div>' +
      '</li>';
    }).join('');

    var ups = this.upsells(res).map(function (u) {
      return '<div class="ycq__upsell">' +
        (u.item.image ? '<img src="' + esc(u.item.image) + '" alt="" loading="lazy" width="80" height="80">' : '') +
        '<span class="ycq__upsell-text">' +
          '<strong>' + esc(u.item.title || u.label) + '</strong>' +
          (u.note ? '<span>' + esc(u.note) + '</span>' : '') +
          miniAdd(u.item, s.addOne) +
        '</span>' +
        '<span class="ycq__upsell-price">' + (u.item.compareAt > u.item.price ? '<s class="ycq__compare">' + esc(formatMoney(u.item.compareAt, fmt)) + '</s> ' : '') + esc(formatMoney(u.item.price, fmt)) + '</span>' +
      '</div>';
    }).join('');

    var routine = (r.routine || []).map(function (step) { return '<li>' + esc(step) + '</li>'; }).join('');
    var trust = (this.cfg.trust || []).map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
    var reviews = (r.reviews || []).map(function (rv) {
      return '<figure class="ycq__review">' +
        (rv.image ? '<img src="' + esc(rv.image) + '" alt="" loading="lazy" width="600" height="600">' : '') +
        '<div class="ycq__review-body">' +
          '<div class="ycq__review-stars" aria-label="5/5">' + STARS + '</div>' +
          '<blockquote>' + esc(rv.text) + '</blockquote>' +
          (rv.name ? '<figcaption>' + esc(rv.name) + (s.verified ? ' · <span>' + esc(s.verified) + '</span>' : '') + '</figcaption>' : '') +
        '</div>' +
      '</figure>';
    }).join('');

    var cta = res.available
      ? '<button type="button" class="ycq__btn ycq__btn--primary ycq__btn--block" data-ycq-action="add" data-ycq-main-cta>' + (this.state.added ? '' : BAG) + '<span>' + esc(this.state.added ? s.addedCta : s.addCta) + '</span></button>'
      : '<p class="ycq__error">' + esc(s.unavailable) + '</p>' +
        (this.cfg.collectionUrl ? '<a class="ycq__btn ycq__btn--secondary ycq__btn--block" href="' + esc(this.cfg.collectionUrl) + '">' + esc(s.browseCollection) + '</a>' : '');

    return '' +
      '<div class="ycq__screen ycq__screen--result">' +
        '<div class="ycq__band">' +
          '<div class="ycq__band-inner">' +
            '<div class="ycq__topbar ycq__topbar--band">' +
              '<button type="button" class="ycq__back" data-ycq-action="back"><span aria-hidden="true">←</span> ' + esc(s.back) + '</button>' +
              '<button type="button" class="ycq__link" data-ycq-action="restart">' + esc(s.restart) + '</button>' +
            '</div>' +
            (heroImage ? '<img class="ycq__curl-img" src="' + esc(heroImage) + '" alt="" width="96" height="96">' : '') +
            '<p class="ycq__pill">' + esc(s.resultKicker) + '</p>' +
            '<h2 class="ycq__match" tabindex="-1" data-ycq-focus><span>' + esc(s.matchLabel) + '</span> ' + esc(r.name) + '</h2>' +
            '<div class="ycq__personal">' + personal + '</div>' +
          '</div>' +
          WAVE +
        '</div>' +
        '<div class="ycq__body">' +
        '<div class="ycq__offer">' +
          '<ul class="ycq__products" role="list">' + cards + '</ul>' +
          (ups ? '<div class="ycq__upsells"><p class="ycq__upsells-title">' + esc(s.upsellTitle) + '</p>' + ups + '</div>' : '') +
          '<div class="ycq__total"><span>' + esc(s.totalLabel) + '</span><span class="ycq__total-price"><s class="ycq__compare" data-ycq-compare hidden></s> <strong data-ycq-total>' + esc(formatMoney(this.sum(this.selection(res)), fmt)) + '</strong></span></div>' +
          '<p class="ycq__saving" data-ycq-saving hidden></p>' +
          '<p class="ycq__shipping" data-ycq-shipping hidden></p>' +
          cta +
          '<p class="ycq__error" data-ycq-error role="alert" hidden></p>' +
          (trust ? '<ul class="ycq__trust" role="list">' + trust + '</ul>' : '') +
        '</div>' +
        (r.why ? '<section class="ycq__block"><h3>' + esc(s.whyTitle) + '</h3><div class="ycq__rte">' + r.why + '</div></section>' : '') +
        (routine ? '<section class="ycq__block"><h3>' + esc(s.routineTitle) + '</h3><ol class="ycq__routine">' + routine + '</ol></section>' : '') +
        (reviews ? '<section class="ycq__block"><h3>' + esc(s.reviewsTitle) + '</h3><div class="ycq__reviews">' + reviews + '</div></section>' : '') +
        (this.cfg.disclaimer ? '<p class="ycq__disclaimer">' + esc(this.cfg.disclaimer) + '</p>' : '') +
        '</div>' +
        (res.available && this.cfg.showSticky ? '<div class="ycq__sticky" data-ycq-sticky aria-hidden="true"><div><span>' + esc(r.name) + '</span><strong data-ycq-total>' + esc(formatMoney(this.sum(this.selection(res)), fmt)) + '</strong></div><button type="button" class="ycq__btn ycq__btn--primary" data-ycq-action="add" tabindex="-1">' + esc(s.stickyCta) + '</button></div>' : '') +
      '</div>';
  };

  Quiz.prototype.afterResultRender = function () {
    var self = this;
    var res = this.resolve();
    if (!this.state.flags.resultViewed) {
      var items = res.result ? res.result.items : [];
      this.trackOnce('resultViewed', 'curl_quiz_result_view', Object.assign({
        quiz_result_id: res.id,
        quiz_primary_result_id: res.primaryId,
        quiz_result_available: res.available,
        quiz_product_ids: items.map(function (i) { return String(i.productId); }),
        quiz_variant_ids: items.map(function (i) { return String(i.variantId); }),
        value: this.sum(items) / 100,
        currency: this.cfg.currency
      }, this.answerParams()));
    }
    this.updateTotals(res);
    var before = this.upsells(res).map(function (u) { return u.key; }).join();
    this.refreshCartState().then(function () {
      if (self.state.step !== STEP_RESULT) return;
      var r2 = self.resolve();
      var after = self.upsells(r2).map(function (u) { return u.key; }).join();
      if (after !== before) self.render(false);
      else self.updateTotals(r2);
    });
    // Sticky CTA på mobil, når hoved-CTA er ude af syne
    var main = this.view.querySelector('[data-ycq-main-cta]');
    var sticky = this.view.querySelector('[data-ycq-sticky]');
    if (sticky) {
      // Flyt sticky-knappen direkte ind i <body>, så temaets transforms/animationer ikke kan flytte den
      var cs = window.getComputedStyle(this.root);
      ['--ycq-btn-bg', '--ycq-btn-text', '--ycq-line', '--ycq-muted', '--ycq-body', '--ycq-ink'].forEach(function (v) {
        var val = cs.getPropertyValue(v);
        if (val) sticky.style.setProperty(v, val.trim());
      });
      sticky.classList.add('ycq__sticky--portal');
      document.body.appendChild(sticky);
      this.stickyEl = sticky;
      sticky.addEventListener('click', function (e) {
        if (e.target.closest('[data-ycq-action="add"]')) { e.preventDefault(); self.addToCart(); }
      });
    }
    if (this.io) { this.io.disconnect(); this.io = null; }
    if (main && sticky && 'IntersectionObserver' in window) {
      this.root.classList.add('ycq--has-sticky');
      // Vis kun når hoved-knappen ikke er synlig OG quizzen stadig er på skærmen
      var vis = { cta: true, quiz: true };
      var body = this.view.querySelector('.ycq__body') || this.root;
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { vis[e.target === main ? 'cta' : 'quiz'] = e.isIntersecting; });
        var show = !vis.cta && vis.quiz;
        if (sticky.classList.contains('is-visible') === show) return;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { rootMargin: '0px 0px -96px 0px' });
      this.io.observe(main);
      this.io.observe(body);
    }
  };

  Quiz.prototype.refreshCartState = function () {
    var self = this;
    var now = Date.now();
    if (this.cartFetchedAt && now - this.cartFetchedAt < 1500) return Promise.resolve();
    this.cartFetchedAt = now;
    return jsonFetch(this.cfg.routes.cart + '.js').then(function (cart) {
      self.cartTotal = cart.total_price || 0;
      self.cartItems = cart.items || [];
    }).catch(function () {});
  };

  Quiz.prototype.updateTotals = function (res) {
    var fmt = this.cfg.moneyFormat;
    var total = this.sum(this.selection(res));
    var els = this.qa('[data-ycq-total]');
    for (var i = 0; i < els.length; i++) els[i].textContent = formatMoney(total, fmt);
    var before = this.compareSum(this.selection(res));
    var saving = before - total;
    var cmp = this.view.querySelector('[data-ycq-compare]');
    var sav = this.view.querySelector('[data-ycq-saving]');
    if (cmp) { cmp.hidden = !(saving > 0); cmp.textContent = saving > 0 ? formatMoney(before, fmt) : ''; }
    if (sav) { sav.hidden = !(saving > 0); sav.textContent = saving > 0 ? tpl(this.s.savingTotal, { amount: formatMoney(saving, fmt) }) : ''; }
    var ship = this.view.querySelector('[data-ycq-shipping]');
    if (!ship || !(this.cfg.freeShipping > 0) || this.cartTotal == null) return;
    var remaining = this.cfg.freeShipping - (this.state.added ? this.cartTotal : this.cartTotal + total);
    ship.hidden = false;
    ship.className = 'ycq__shipping' + (remaining <= 0 ? ' is-free' : '');
    ship.textContent = remaining <= 0
      ? this.s.shippingFree
      : tpl(this.s.shippingRemaining, { amount: formatMoney(remaining, fmt) });
  };

  /* ---------- kurv ---------- */
  Quiz.prototype.showError = function (msg) {
    var el = this.view.querySelector('[data-ycq-error]');
    if (!el) return;
    el.hidden = !msg;
    el.textContent = msg || '';
  };

  Quiz.prototype.setLoading = function (on) {
    var btns = this.qa('[data-ycq-action="add"]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].disabled = on;
      btns[i].classList.toggle('is-loading', on);
    }
  };

  Quiz.prototype.addToCart = function () {
    var self = this;
    if (this.busy) return;
    var res = this.resolve();
    if (this.state.added) {
      this.busy = true;
      return jsonFetch(this.cfg.routes.cart + '.js').then(function (cart) {
        self.busy = false;
        var ids = (cart.items || []).map(function (li) { return li.variant_id; });
        var stillThere = res.result && self.selection(res).every(function (i) { return ids.indexOf(i.variantId) !== -1; });
        if (stillThere) return self.openCart();
        self.state.added = false;
        self.save();
        self.addToCart();
      }).catch(function () { self.busy = false; self.openCart(); });
    }
    if (!res.available) { this.showError(this.s.unavailable); return; }

    var items = this.selection(res);
    this.busy = true;
    this.setLoading(true);
    this.showError('');

    // Hent kurven først, så tilvalg (fx shampoo+balsam) ikke tilføjes dobbelt
    jsonFetch(this.cfg.routes.cart + '.js').catch(function () { return { items: [] }; }).then(function (cart) {
      var inCart = {};
      (cart.items || []).forEach(function (li) { inCart[li.variant_id] = true; });
      var base = res.result.items.map(function (i) { return i.variantId; });
      var payload = [];
      var seen = {};
      items.forEach(function (i) {
        var isUpsell = base.indexOf(i.variantId) === -1;
        if (seen[i.variantId]) return; // aldrig samme variant to gange i samme tilføjelse
        var addedBefore = (self.state.addedIds || []).indexOf(i.variantId) !== -1;
        if (inCart[i.variantId] && (isUpsell || addedBefore)) return; // ligger allerede i kurven – tilføj ikke dobbelt
        seen[i.variantId] = true;
        payload.push({ id: i.variantId, quantity: i.qty || 1 });
      });
      if (!payload.length) return payload; // alt ligger allerede i kurven
      return jsonFetch(self.cfg.routes.cartAdd + '.js', {
        method: 'POST',
        body: JSON.stringify({ items: payload })
      }).then(function () { return payload; });
    }).then(function (payload) {
      self.state.added = true;
      self.state.addedIds = (self.state.addedIds || []).concat(payload.map(function (x) { return x.id; }));
      self.save();
      var added = items.filter(function (i) { return payload.some(function (p) { return p.id === i.variantId; }); });
      self.track('curl_quiz_add_to_cart', {
        quiz_result_id: res.id,
        quiz_product_ids: added.map(function (i) { return String(i.productId); }),
        quiz_variant_ids: added.map(function (i) { return String(i.variantId); }),
        quiz_upsells: self.upsells(res).filter(function (u) { return self.optOn(u); }).map(function (u) { return u.key; }),
        value: self.sum(added) / 100,
        currency: self.cfg.currency
      });
      // Gem quizresultatet på ordren (skjult kurv-attribut) til omsætning pr. resultat
      jsonFetch(self.cfg.routes.cartUpdate + '.js', {
        method: 'POST',
        body: JSON.stringify({ attributes: { _curl_quiz_result: res.id, _curl_quiz_answers: QUESTION_IDS.map(function (q) { return self.state.answers[q] || '-'; }).join('|') } })
      }).catch(function () {}).then(function () {
        self.busy = false;
        self.setLoading(false);
        var btns = self.qa('[data-ycq-action="add"]');
        for (var i = 0; i < btns.length; i++) {
          if (btns[i].hasAttribute('data-ycq-main-cta')) btns[i].innerHTML = '<span>' + esc(self.s.addedCta) + '</span>';
        }
        self.cartFetchedAt = 0;
        self.refreshCartState().then(function () { self.updateTotals(res); });
        self.openCart();
      });
    }).catch(function (err) {
      self.busy = false;
      self.setLoading(false);
      var msg = self.s.addError;
      if (err && err.status === 422 && err.body && err.body.description) msg = err.body.description;
      self.showError(msg);
      if (window.console) console.warn('[curl-quiz] add to cart failed', err);
    });
  };

  Quiz.prototype.findItem = function (variantId) {
    var res = this.resolve();
    var pool = (res.result ? res.result.items : []).concat(this.upsells(res).map(function (u) { return u.item; }));
    for (var i = 0; i < pool.length; i++) if (String(pool[i].variantId) === String(variantId)) return { item: pool[i], res: res };
    return null;
  };

  Quiz.prototype.addOne = function (btn) {
    var self = this;
    if (btn.disabled) return;
    var found = this.findItem(btn.getAttribute('data-variant'));
    if (!found) return;
    var item = found.item;
    btn.disabled = true;
    btn.classList.add('is-loading');
    this.showError('');
    jsonFetch(this.cfg.routes.cartAdd + '.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: item.variantId, quantity: 1 }] })
    }).then(function () {
      btn.classList.remove('is-loading');
      btn.classList.add('is-done');
      btn.textContent = self.s.addedOne;
      self.state.addedIds = (self.state.addedIds || []).concat([item.variantId]);
      self.save();
      self.track('curl_quiz_add_single', {
        quiz_result_id: found.res.id,
        quiz_product_ids: [String(item.productId)],
        quiz_variant_ids: [String(item.variantId)],
        value: item.price / 100,
        currency: self.cfg.currency
      });
      self.cartFetchedAt = 0;
      self.refreshCartState().then(function () { self.updateTotals(found.res); });
      self.openCart();
      setTimeout(function () {
        btn.disabled = false;
        btn.classList.remove('is-done');
        btn.textContent = self.s.addOne;
      }, 2500);
    }).catch(function (err) {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      var msg = self.s.addError;
      if (err && err.status === 422 && err.body && err.body.description) msg = err.body.description;
      self.showError(msg);
    });
  };

  Quiz.prototype.openCart = function () {
    var cartUrl = this.cfg.routes.cart;
    var go = function () { window.location.href = cartUrl; };
    if (this.cfg.cartBehavior !== 'drawer') return go();

    // Minimog OS 2.0
    var C = window.MinimogTheme && window.MinimogTheme.Cart;
    if (C && C.enableCartDrawer !== false && typeof C.openCartDrawer === 'function') {
      Promise.resolve()
        .then(function () { return typeof C.refreshCart === 'function' ? C.refreshCart() : null; })
        .then(function () { return typeof C.renderNewCart === 'function' ? C.renderNewCart() : null; })
        .then(function () {
          try { if (typeof C.updateCartCount === 'function') C.updateCartCount(C.cart); } catch (e) {}
          C.openCartDrawer();
          // Hvis skuffen ikke er synlig efter et øjeblik (fx på nogle mobiler), gå til kurven
          setTimeout(function () {
            var w = document.querySelector('.scd__wrapper');
            if (w && w.classList.contains('hidden')) go();
          }, 1200);
        })
        .catch(function (e) {
          if (window.console) console.warn('[curl-quiz] cart drawer fallback', e);
          go();
        });
      return;
    }
    // Andre temaer: giv besked og send til kurven
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    go();
  };

  /* ------------------------------------------------------------------ *
   * Init
   * ------------------------------------------------------------------ */
  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-ycq]:not([data-ycq-ready])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-ycq-ready', '');
      try { roots[i].__ycq = new Quiz(roots[i]); } catch (e) { if (window.console) console.error('[curl-quiz] init failed', e); }
    }
  }

  window.YuaiaCurlQuiz = { pickResult: pickResult, formatMoney: formatMoney, init: init, Quiz: Quiz };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
